import React, { useEffect, useState } from "react";
import { format } from "date-fns";

const ratingItems = [
  { label: "Task Completion", key: "taskCompletion", icon: "✓" },
  { label: "Quality of Task", key: "quality", icon: "◈" },
  { label: "Team Work", key: "teamwork", icon: "⬡" },
  { label: "Initiative", key: "initiative", icon: "↑" },
  { label: "Learning", key: "learning", icon: "◎" },
];

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.55)",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1050,
    padding: "16px",
  },
  modal: {
    background: "#ffffff",
    borderRadius: "20px",
    width: "100%",
    maxWidth: "780px",
    maxHeight: "92vh",
    overflowY: "hidden",
    boxShadow: "0 32px 64px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.06)",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    padding: "22px 28px 18px",
    borderBottom: "1px solid #f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    background: "#fff",
    zIndex: 2,
    borderRadius: "20px 20px 0 0",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIconWrap: {
    width: "42px",
    height: "42px",
    borderRadius: "12px",
    background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    flexShrink: 0,
  },
  headerTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "#0f172a",
    lineHeight: 1.2,
    fontFamily: "inherit",
  },
  headerSub: {
    fontSize: "12px",
    color: "#94a3b8",
    marginTop: "2px",
    fontFamily: "inherit",
  },
  closeBtn: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    border: "1px solid #e2e8f0",
    background: "transparent",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    color: "#64748b",
    transition: "all 0.15s",
    lineHeight: 1,
  },
  body: {
    padding: "24px 28px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    overflowY: "auto",
    flex: 1,
    minHeight: 0,
  },
  twoCol: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },
  card: {
    background: "#f8fafc",
    borderRadius: "14px",
    border: "1px solid #e2e8f0",
    padding: "18px",
  },
  sectionLabel: {
    fontSize: "10.5px",
    fontWeight: "700",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#94a3b8",
    marginBottom: "14px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "inherit",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  fieldRow: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  fieldLabel: {
    fontSize: "11px",
    fontWeight: "600",
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    fontFamily: "inherit",
  },
  readonlyField: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    padding: "9px 13px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#0f172a",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontFamily: "inherit",
  },
  select: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    padding: "9px 13px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#0f172a",
    width: "100%",
    cursor: "pointer",
    outline: "none",
    fontFamily: "inherit",
    appearance: "none",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24'%3E%3Cpath fill='%2394a3b8' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 12px center",
    paddingRight: "32px",
  },
  avatarCircle: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "11px",
    fontWeight: "700",
    color: "#fff",
    flexShrink: 0,
    fontFamily: "inherit",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "8px",
  },
  statCell: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    padding: "11px 13px",
  },
  statLabel: {
    fontSize: "10px",
    fontWeight: "600",
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: "3px",
    fontFamily: "inherit",
  },
  statVal: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#0f172a",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "inherit",
  },
  completedBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "3px",
    background: "#dcfce7",
    color: "#166534",
    fontSize: "10px",
    fontWeight: "700",
    padding: "2px 7px",
    borderRadius: "999px",
    fontFamily: "inherit",
  },
  ratingsCard: {
    background: "#f8fafc",
    borderRadius: "14px",
    border: "1px solid #e2e8f0",
    padding: "18px",
  },
  ratingRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 13px",
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "11px",
    marginBottom: "8px",
    transition: "border-color 0.15s, box-shadow 0.15s",
    cursor: "default",
  },
  ratingLabel: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#334155",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontFamily: "inherit",
  },
  ratingIcon: {
    width: "24px",
    height: "24px",
    borderRadius: "7px",
    background: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    color: "#475569",
    flexShrink: 0,
  },
  starsWrap: {
    display: "flex",
    gap: "3px",
  },
  scoreCard: {
    background: "transparent",
    borderRadius: "14px",
    border: "1px solid #e2e8f0",
    padding: "20px 22px",
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  scoreLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    flexShrink: 0,
  },
  scoreNum: {
    fontSize: "36px",
    fontWeight: "800",
    color: "#fff",
    lineHeight: 1,
    fontFamily: "inherit",
  },
  scoreDenom: {
    fontSize: "12px",
    color: "#64748b",
    fontFamily: "inherit",
  },
  scoreRight: {
    flex: 1,
  },
  gradeBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    padding: "4px 13px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: "700",
    marginBottom: "10px",
    fontFamily: "inherit",
  },
  progressTrack: {
    background: "#f1f5f9",
    borderRadius: "999px",
    height: "6px",
    overflow: "hidden",
    marginBottom: "5px",
  },
  progressFill: {
    height: "100%",
    borderRadius: "999px",
    transition: "width 0.4s ease",
  },
  progressLabels: {
    display: "flex",
    justifyContent: "space-between",
  },
  progressLabel: {
    fontSize: "10px",
    color: "#94a3b8",
    fontFamily: "inherit",
  },
  scoreRingWrap: {
    position: "relative",
    width: "80px",
    height: "80px",
    flexShrink: 0,
  },
  scoreRingInner: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  remarksCard: {
    background: "#f8fafc",
    borderRadius: "14px",
    border: "1px solid #e2e8f0",
    padding: "18px",
  },
  textarea: {
    width: "100%",
    minHeight: "80px",
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    padding: "11px 13px",
    fontSize: "13px",
    color: "#0f172a",
    resize: "vertical",
    outline: "none",
    fontFamily: "inherit",
    lineHeight: 1.6,
    transition: "border-color 0.15s",
  },
  footer: {
    padding: "16px 28px",
    borderTop: "1px solid #f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    background: "#fff",
    borderRadius: "0 0 20px 20px",
  },
  footerNote: {
    fontSize: "12px",
    color: "#94a3b8",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontFamily: "inherit",
  },
  btnGroup: {
    display: "flex",
    gap: "8px",
  },
  btnGhost: {
    padding: "9px 20px",
    borderRadius: "10px",
    border: "1px solid #e2e8f0",
    background: "transparent",
    fontSize: "13px",
    fontWeight: "600",
    color: "#64748b",
    cursor: "pointer",
    fontFamily: "inherit",
    transition: "all 0.15s",
  },
  btnPrimary: {
    padding: "9px 22px",
    borderRadius: "10px",
    border: "none",
    background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
    fontSize: "13px",
    fontWeight: "700",
    color: "#fff",
    cursor: "pointer",
    fontFamily: "inherit",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    boxShadow: "0 4px 14px rgba(59,130,246,0.4)",
    transition: "all 0.15s",
  },
};

function getInitials(name = "") {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

function StarRating({ value = 0, onChange }) {
  const [hovered, setHovered] = useState(0);

  return (
    <div style={styles.starsWrap}>
      {[1, 2, 3, 4, 5].map((star) => {
        const active = star <= (hovered || value);
        return (
          <span
            key={star}
            onClick={() => onChange(star)}
            onMouseEnter={() => setHovered(star)}
            onMouseLeave={() => setHovered(0)}
            style={{
              fontSize: "20px",
              cursor: "pointer",
              color: active ? "#f59e0b" : "#cbd5e1",
              transition: "color 0.12s, transform 0.1s",
              transform: hovered === star ? "scale(1.25)" : "scale(1)",
              display: "inline-block",
              lineHeight: 1,
            }}
          >
            ★
          </span>
        );
      })}
    </div>
  );
}

function ScoreRing({ score, maxScore = 5, ringColor }) {
  const size = 80;
  const strokeWidth = 7;
  const radius = (size - strokeWidth) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = score > 0 ? score / maxScore : 0;
  const offset = circ * (1 - pct);

  return (
    <div style={styles.scoreRingWrap}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        style={{ transform: "rotate(-90deg)" }}
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#e2e8f0"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={ringColor || "#3b82f6"}
          strokeWidth={strokeWidth}
          strokeDasharray={circ.toFixed(2)}
          strokeDashoffset={offset.toFixed(2)}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.5s ease" }}
        />
      </svg>
      <div style={styles.scoreRingInner}>
        <span style={{ fontSize: "18px", fontWeight: "800", color: "#0f172a", lineHeight: 1 }}>
          {score > 0 ? score : "—"}
        </span>
        <span style={{ fontSize: "10px", color: "#64748b" }}>/ 5</span>
      </div>
    </div>
  );
}

const DEV_ACTIVE  = ["PENDING", "IN_PROGRESS", "READY TO REVIEW"];
// Tester is "still working" only during READY TO TEST and IN TESTING.
// If task moves forward (READY TO UPDATE, COMPLETED) OR is sent back (PENDING, IN_PROGRESS),
// the tester's part is done in both cases.
const TEST_ACTIVE = ["READY TO TEST", "IN TESTING"];

// Per-task role is set by AdminTimesheetGrid from audit history:
//   "developer" → completed once past READY TO REVIEW
//   "tester"    → completed once past READY TO UPDATE
function getCompletedTasks(taskList) {
  return taskList.filter((t) => {
    const exclusions = t.employeeRole === "tester" ? TEST_ACTIVE : DEV_ACTIVE;
    return !exclusions.includes(t.status);
  }).length;
}

function getGradeMeta(grade) {
  if (grade.startsWith("A"))
    return { bg: "#dcfce7", color: "#166534", ringColor: "#22c55e", barColor: "#22c55e" };
  if (grade.startsWith("B"))
    return { bg: "#dbeafe", color: "#1e40af", ringColor: "#3b82f6", barColor: "#3b82f6" };
  if (grade === "C")
    return { bg: "#fef9c3", color: "#854d0e", ringColor: "#eab308", barColor: "#eab308" };
  return { bg: "#fee2e2", color: "#991b1b", ringColor: "#ef4444", barColor: "#ef4444" };
}

const AdminTimesheetEvaluationModal = ({
  show,
  selectedEmployee,
  manager,
  startDate,
  endDate,
  viewMode,
  tasks = [],
  billingHours = 0,
  availableHours = 0,
  initialData = null,
  submitLabel = "Submit Evaluation",
  onSubmit,
  onClose,
}) => {
  const [evaluationData, setEvaluationData] = useState(null);
  const [errors, setErrors] = useState({});

  const buildInitialEvaluationData = () => {
    if (!initialData) return null;

    return {
      ...initialData,
      managerName:
        initialData.managerName ||
        (manager ? `${manager.firstName || ""} ${manager.lastName || ""}`.trim() : "Manager"),
      employeeName:
        initialData.employeeName ||
        (selectedEmployee
          ? `${selectedEmployee.firstName || ""} ${selectedEmployee.lastName || ""}`.trim()
          : "Employee"),
      availableHours: initialData.availableHours || 0,
      ratings: initialData.ratings || {
        taskCompletion: initialData.taskCompletion || 0,
        quality: initialData.quality || 0,
        teamwork: initialData.teamwork || 0,
        initiative: initialData.initiative || 0,
        learning: initialData.learning || 0,
      },
      finalScore: initialData.finalScore || 0,
      grade: initialData.grade || "-",
      remarks: initialData.remarks || "",
    };
  };

  const calculateEvaluationData = () => {
    if (!selectedEmployee) return null;

    const managerName = manager
      ? `${manager.firstName || ""} ${manager.lastName || ""}`.trim()
      : "Manager";

    const employeeName =
      `${selectedEmployee.firstName || ""} ${selectedEmployee.lastName || ""}`.trim();
    const month = startDate ? format(startDate, "MMMM yyyy") : "";
    const week =
      viewMode === "weekly" && startDate && endDate
        ? `${format(startDate, "dd MMM")} - ${format(endDate, "dd MMM")}`
        : "";

    return {
      managerName,
      employeeName,
      employeeType: selectedEmployee.designation || selectedEmployee.employeeType || "",
      month,
      week,
      assignedTasks: tasks.length,
      completedTasks: getCompletedTasks(tasks),
      billingHours,
      availableHours,
      ratings: {
        taskCompletion: 0,
        quality: 0,
        teamwork: 0,
        initiative: 0,
        learning: 0,
      },
      finalScore: 0,
      grade: "-",
      remarks: "",
    };
  };

  const calculateOverallPerformance = (ratings = {}) => {
    const values = Object.values(ratings)
      .map(Number)
      .filter((v) => v > 0);

    if (!values.length) return { score: 0, grade: "-" };

    const avg = values.reduce((a, b) => a + b, 0) / values.length;

    let grade = "C";
    if (avg >= 4.5) grade = "A+";
    else if (avg >= 4) grade = "A";
    else if (avg >= 3.5) grade = "B+";
    else if (avg >= 3) grade = "B";
    else if (avg >= 2) grade = "C";
    else grade = "D";

    return { score: parseFloat(avg.toFixed(2)), grade };
  };

  useEffect(() => {
    if (!show) return;
    setEvaluationData(buildInitialEvaluationData() || calculateEvaluationData());
    setErrors({});
  }, [show, initialData, selectedEmployee, manager, startDate, endDate, viewMode, tasks, billingHours, availableHours]);

  useEffect(() => {
    if (!evaluationData?.ratings) return;
    const { score, grade } = calculateOverallPerformance(evaluationData.ratings);
    setEvaluationData((prev) => ({ ...prev, finalScore: score, grade }));
  }, [evaluationData?.ratings]);

  useEffect(() => {
    if (evaluationData?.week?.trim()) setErrors((prev) => ({ ...prev, week: undefined }));
  }, [evaluationData?.week]);

  const validate = () => {
    const errs = {};
    if (!evaluationData.week?.trim()) errs.week = "Week is required";
    const unrated = ratingItems.filter((item) => !(evaluationData.ratings?.[item.key] > 0));
    if (unrated.length > 0) errs.ratings = `Please rate: ${unrated.map((i) => i.label).join(", ")}`;
    return errs;
  };

  const handleSubmit = () => {
    if (!evaluationData) return;
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    setErrors({});
    onSubmit(evaluationData);
  };

  if (!show || !evaluationData) return null;

  const { ratings = {}, finalScore = 0, grade = "-" } = evaluationData;
  const completionPct =
    evaluationData.assignedTasks > 0
      ? Math.round((evaluationData.completedTasks / evaluationData.assignedTasks) * 100)
      : 0;
  const gradeMeta = getGradeMeta(grade);

  return (
    <div style={styles.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={styles.modal} role="dialog" aria-modal="true">

        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerLeft}>
            <div style={styles.headerIconWrap}>📋</div>
            <div>
              <div style={styles.headerTitle}>Employee Evaluation</div>
              <div style={styles.headerSub}>
                {evaluationData.month}
                {evaluationData.week ? ` · ${evaluationData.week}` : ""}
              </div>
            </div>
          </div>
          <button style={styles.closeBtn} onClick={onClose} aria-label="Close">✕</button>
        </div>

        {/* Body */}
        <div style={styles.body}>

          {/* Row 1: Personnel + Work Summary */}
          <div style={styles.twoCol}>
            {/* Personnel */}
            <div style={styles.card}>
              <div style={styles.sectionLabel}>👤 Personnel</div>
              <div style={styles.fieldGroup}>
                <div style={styles.fieldRow}>
                  <div style={styles.fieldLabel}>Manager</div>
                  <div style={styles.readonlyField}>
                    <div style={{ ...styles.avatarCircle, background: "linear-gradient(135deg,#f59e0b,#ef4444)" }}>
                      {getInitials(evaluationData.managerName)}
                    </div>
                    {evaluationData.managerName || "—"}
                  </div>
                </div>

                <div style={styles.fieldRow}>
                  <div style={styles.fieldLabel}>Employee</div>
                  <div style={styles.readonlyField}>
                    <div style={styles.avatarCircle}>
                      {getInitials(evaluationData.employeeName)}
                    </div>
                    {evaluationData.employeeName || "—"}
                  </div>
                </div>

                <div style={styles.fieldRow}>
                  <div style={styles.fieldLabel}>Position</div>
                  <div style={styles.readonlyField}>
                    <span style={{ fontSize: 15 }}>🏷️</span>
                    {evaluationData.employeeType || "—"}
                  </div>
                </div>

              </div>
            </div>

            {/* Work Summary */}
            <div style={styles.card}>
              <div style={styles.sectionLabel}>📊 Work Summary</div>
              <div style={styles.statsGrid}>
                <div style={styles.statCell}>
                  <div style={styles.statLabel}>Month</div>
                  <div style={styles.statVal}>{evaluationData.month || "—"}</div>
                </div>
                <div style={{ ...styles.statCell, ...(errors.week ? { border: "1px solid #fca5a5", background: "#fff5f5" } : {}) }}>
                  <div style={{ ...styles.statLabel, ...(errors.week ? { color: "#dc2626" } : {}) }}>
                    Week {errors.week && <span style={{ fontSize: 9, fontWeight: 700, color: "#dc2626", marginLeft: 4 }}>● Required</span>}
                  </div>
                  <div style={{ ...styles.statVal, color: errors.week && !evaluationData.week ? "#dc2626" : "#0f172a" }}>
                    {evaluationData.week || <span style={{ fontSize: 13, color: "#fca5a5", fontStyle: "italic" }}>Not set</span>}
                  </div>
                </div>
                <div style={styles.statCell}>
                  <div style={styles.statLabel}>Assigned</div>
                  <div style={styles.statVal}>{evaluationData.assignedTasks} tasks</div>
                </div>
                <div style={styles.statCell}>
                  <div style={styles.statLabel}>Completed</div>
                  <div style={styles.statVal}>
                    {evaluationData.completedTasks}
                    {completionPct > 0 && (
                      <span style={styles.completedBadge}>✓ {completionPct}%</span>
                    )}
                  </div>
                </div>
                <div style={{ ...styles.statCell, gridColumn: "span 2" }}>
                  <div style={styles.statLabel}>Billing Hours</div>
                  <div style={styles.statVal}>{evaluationData.billingHours} hrs</div>
                </div>
                <div style={{ ...styles.statCell, gridColumn: "span 2" }}>
                  <div style={styles.statLabel}>Available Hours</div>
                  <div style={styles.statVal}>{evaluationData.availableHours} hrs</div>
                </div>
              </div>
            </div>
          </div>

          {/* Row 2: Ratings */}
          <div style={{ ...styles.ratingsCard, ...(errors.ratings ? { border: "1px solid #fca5a5" } : {}) }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "14px" }}>
              <div style={styles.sectionLabel}>⭐ Performance Ratings</div>
              {errors.ratings && (
                <span style={{ fontSize: "11px", fontWeight: 700, color: "#dc2626", background: "#fee2e2", padding: "3px 9px", borderRadius: 999 }}>
                  ⚠ All ratings required
                </span>
              )}
            </div>
            {ratingItems.map((item, idx) => {
              const isUnrated = errors.ratings && !(ratings[item.key] > 0);
              return (
                <div key={item.key} style={{ ...styles.ratingRow, marginBottom: idx === ratingItems.length - 1 ? 0 : "8px", ...(isUnrated ? { borderColor: "#fca5a5", background: "#fff5f5" } : {}) }}>
                  <div style={styles.ratingLabel}>
                    <div style={{ ...styles.ratingIcon, ...(isUnrated ? { background: "#fee2e2", color: "#dc2626" } : {}) }}>{item.icon}</div>
                    <span style={isUnrated ? { color: "#dc2626" } : {}}>{item.label}</span>
                    {isUnrated && <span style={{ fontSize: 10, color: "#fca5a5", fontWeight: 600 }}>— not rated</span>}
                  </div>
                  <StarRating
                    value={ratings[item.key] || 0}
                    onChange={(val) => {
                      setErrors((prev) => ({ ...prev, ratings: undefined }));
                      setEvaluationData((prev) => ({
                        ...prev,
                        ratings: { ...(prev.ratings || {}), [item.key]: val },
                      }));
                    }}
                  />
                </div>
              );
            })}
          </div>

          {/* Row 3: Score */}
          <div style={styles.scoreCard}>
            <ScoreRing score={finalScore} ringColor={gradeMeta.ringColor} />

            <div style={styles.scoreRight}>
              <div
                style={{
                  ...styles.gradeBadge,
                  background: gradeMeta.bg,
                  color: gradeMeta.color,
                }}
              >
                🏅 Grade {grade}
              </div>
              <div style={styles.progressTrack}>
                <div
                  style={{
                    ...styles.progressFill,
                    width: `${(finalScore / 5) * 100}%`,
                    background: gradeMeta.barColor,
                  }}
                />
              </div>
              <div style={styles.progressLabels}>
                <span style={styles.progressLabel}>0</span>
                <span style={styles.progressLabel}>Overall performance</span>
                <span style={styles.progressLabel}>5</span>
              </div>
            </div>
          </div>

          {/* Row 4: Remarks */}
          <div style={styles.remarksCard}>
            <div style={styles.sectionLabel}>💬 Remarks</div>
            <textarea
              style={styles.textarea}
              rows={3}
              placeholder="Add feedback or comments for this evaluation period…"
              value={evaluationData.remarks || ""}
              onChange={(e) =>
                setEvaluationData((prev) => ({ ...prev, remarks: e.target.value }))
              }
              onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
              onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
            />
          </div>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <div style={styles.footerNote}></div>
          <div style={styles.btnGroup}>

             <button
              style={styles.btnPrimary}
              onClick={handleSubmit}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.9")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
            >
              Save
            </button>
            <button
              style={styles.btnGhost}
              onClick={onClose}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f8fafc")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              Cancel
            </button>
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminTimesheetEvaluationModal;
